<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">6</h2>
<p class="vers"><span>Pflück</span> diese kleine
Blume und<br class="calibre1"/>
nimm sie und zögre nicht, ich fürchte, sie<br class="calibre1"/>
welkt und fällt in den Staub.</p>
<p class="vers">Sie wird keinen Platz in deinem Kranze<br class="calibre1"/>
finden, doch ehre sie mit dem Schmerzensdruck<br class="calibre1"/>
deiner Hand und pflücke sie<br class="calibre1"/>
ab. Ich fürchte, der Tag könnt enden, eh<br class="calibre1"/>
ich es merke und die Zeit des Opferns<br class="calibre1"/>
vergehn.</p>
<p class="vers">Ist auch die Farbe nicht tief und ihr<br class="calibre1"/>
Duft nur schwach, nütze die Blume für<br class="calibre1"/>
deinen Dienst und pflück sie, solange es<br class="calibre1"/>
Zeit ist. <a id="page9" title="wedi/cal"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?44399509